import axios from 'axios';

export const fetchUserDetails = async (accessToken) => {
  console.log("BACKEND_URL:", process.env.REACT_APP_BACKEND_URL)
    const response = await fetch(process.env.REACT_APP_BACKEND_URL + 'get_user_details', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ access_token: accessToken }),
    });
  
    if (!response.ok) throw new Error(`Error ${response.status}`);
    return await response.json();
  };
  
  export const fetchModels = async (tenantId, accessToken, db_type) => {
    const response = await fetch(process.env.REACT_APP_BACKEND_URL + 'load_models', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ tenant_id_list: [tenantId], access_token: accessToken, db_type: db_type }),
    });
  
    if (!response.ok) throw new Error(`Error ${response.status}`);
    return await response.json();
  };
  
  export const submitBatch = async (data) => {
    const response = await fetch(process.env.REACT_APP_BACKEND_URL + 'batch_ask', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });
  
    if (!response.ok) throw new Error('Failed to submit batch');
    return await response.json();
  };
  
  export const checkBatchExists = async (batchId) => {
    console.log('checking if batch exists, going to:')
    console.log(`${process.env.REACT_APP_BACKEND_URL}results/${batchId}`)
    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}results/${batchId}`)
    console.log('response:', response)

    return response.ok; // Returns true if batch exists
  };


  

  export const uploadCSV = async (formData) => {
    const accessToken = sessionStorage.getItem('access_token'); // Get the access token
    try {
      const response = await axios.post(
        process.env.REACT_APP_BACKEND_URL + 'batch_ask', // Replace with your actual API endpoint for uploading CSVs
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      return response.data; // Assumes the API returns data like { batch_id: '...' }
    } catch (error) {
      console.error('Error uploading CSV:', error);
      throw error;
    }
  };